//Version:0.0.1
//Author:Harsha
//Last Edit:Harsha
//Modified Date:26-08-2025
import instrumentActionTypes from './instrument.types';

/*************************** START - GET ALL INSTRUMENT **************************/
export const getInstrumentListStart = (getData: any) => ({
	type: instrumentActionTypes.GET_INSTRUMENT_LIST_START,
	payload: getData,
});

export const getInstrumentListSuccess = (successData: any) => ({
	type: instrumentActionTypes.GET_INSTRUMENT_LIST_SUCCESS,
	payload: successData,
});

export const getInstrumentListFailure = (failureData: any) => ({
	type: instrumentActionTypes.GET_INSTRUMENT_LIST_FAILURE,
	payload: failureData,
});

export const getInstrumentListResponseResetStart = () => ({
	type: instrumentActionTypes.GET_INSTRUMENT_LIST_RESPONSE_RESET,
});

export const getInstrumentListResponseChanged = () => ({
	type: instrumentActionTypes.GET_INSTRUMENT_LIST_RESPONSE_CHANGED,
});
/*************************** END - GET ALL INSTRUMENT *****************************/

/************************** START - CREATE INSTRUMENT *****************************/
export const createInstrumentStart = (createData: any) => ({
	type: instrumentActionTypes.CREATE_INSTRUMENT_START,
	payload: createData,
});

export const createInstrumentSuccess = (successData: any) => ({
	type: instrumentActionTypes.CREATE_INSTRUMENT_SUCCESS,
	payload: successData,
});

export const createInstrumentFailure = (failureData: any) => ({
	type: instrumentActionTypes.CREATE_INSTRUMENT_FAILURE,
	payload: failureData,
});
export const createInstrumentResponseReset = () => ({
	type: instrumentActionTypes.CREATE_INSTRUMENT_RESPONSE_RESET,
});

export const createInstrumentResponseChanged = () => ({
	type: instrumentActionTypes.CREATE_INSTRUMENT_RESPONSE_CHANGED,
});
/************************** END - CREATE INSTRUMENT ********************************/

/******************** START - GET PARTICULAR INSTRUMENT INFO ***********************/
export const getParticularInstrumentStart = (getData: any) => ({
	type: instrumentActionTypes.GET_PARTICULAR_INSTRUMENT_START,
	payload: getData,
});

export const getParticularInstrumentSuccess = (successData: any) => ({
	type: instrumentActionTypes.GET_PARTICULAR_INSTRUMENT_SUCCESS,
	payload: successData,
});

export const getParticularInstrumentFailure = (failureData: any) => ({
	type: instrumentActionTypes.GET_PARTICULAR_INSTRUMENT_FAILURE,
	payload: failureData,
});
export const getParticularInstrumentResponseReset = () => ({
	type: instrumentActionTypes.GET_PARTICULAR_INSTRUMENT_RESPONSE_RESET,
});

export const getParticularInstrumentResponseChanged = () => ({
	type: instrumentActionTypes.GET_PARTICULAR_INSTRUMENT_RESPONSE_CHANGED,
});
/********************* END - GET PARTICULAR INSTRUMENT INFO *************************/

/************************* START - DELETE INSTRUMENT INFO ***************************/
export const deleteInstrumentStart = (deleteData: any) => ({
	type: instrumentActionTypes.DELETE_INSTRUMENT_START,
	payload: deleteData,
});

export const deleteInstrumentSuccess = (successData: any) => ({
	type: instrumentActionTypes.DELETE_INSTRUMENT_SUCCESS,
	payload: successData,
});

export const deleteInstrumentFailure = (failureData: any) => ({
	type: instrumentActionTypes.DELETE_INSTRUMENT_FAILURE,
	payload: failureData,
});
export const deleteInstrumentResponseReset = () => ({
	type: instrumentActionTypes.DELETE_INSTRUMENT_RESPONSE_RESET,
});

export const deleteInstrumentResponseChanged = () => ({
	type: instrumentActionTypes.DELETE_INSTRUMENT_RESPONSE_CHANGED,
});
/************************** END - DELETE INSTRUMENT INFO ****************************/

/************************** START - UPDATE INSTRUMENT INFO **************************/
export const updateInstrumentStart = (updateData: any) => ({
	type: instrumentActionTypes.UPDATE_INSTRUMENT_START,
	payload: updateData,
});

export const updateInstrumentSuccess = (successData: any) => ({
	type: instrumentActionTypes.UPDATE_INSTRUMENT_SUCCESS,
	payload: successData,
});

export const updateInstrumentFailure = (failureData: any) => ({
	type: instrumentActionTypes.UPDATE_INSTRUMENT_FAILURE,
	payload: failureData,
});
export const updateInstrumentResponseReset = () => ({
	type: instrumentActionTypes.UPDATE_INSTRUMENT_RESPONSE_RESET,
});

export const updateInstrumentResponseChanged = () => ({
	type: instrumentActionTypes.UPDATE_INSTRUMENT_RESPONSE_CHANGED,
});
/************************** END - UPDATE INSTRUMENT INFO *****************************/
